module.exports = __webpack_public_path__ + "assets/img/num-6.3764a12d.svg";